// @flow
import React from 'react'

// components
import ErrorsPanelItem from './ErrorsPanelItem'

// types
import type { ValidationErrorsType } from '../../Types/ValidationError'

type ErrorsDrawerProps = {
  debug: boolean,
  errors: ValidationErrorsType,
  labelValue: '',
  prefix: '',
  texts: any,
}

const ErrorsDrawer = (props: ErrorsDrawerProps) => {
  return (
    props.errors.error_type
      // $FlowIssue
      ? <ErrorsPanelItem
        error={props.errors}
        id={`${props.prefix}-error`}
        key={`${props.prefix}-error`}
        label={props.texts || (props.debug ? `undefined ${props.prefix}` : '')}
        labelValue={props.labelValue}
        prefix={`${props.prefix}`}
        showLabel={false}
      />
      : Object.keys(props.errors).map<Object | null>(errorGroup => {
        if (Array.isArray(props.errors[errorGroup])) {
          return (
            props.errors[errorGroup].map((error, index) => ([
              props.debug &&
              <p className='text-secondary' key={`${errorGroup}-error-array-debug`}>{errorGroup} - {index}</p>,
              // $FlowIssue
              <ErrorsDrawer
                debug={props.debug}
                errors={error}
                key={`${errorGroup}-error-array`}
                labelValue={`${error.item_index + 1}`}
                prefix={`${props.prefix}${errorGroup}.`}
                texts={props.texts[errorGroup] || props.texts}
              />
            ]))
          )
        } else if (Object.keys(props.errors[errorGroup]).filter(groupKey => !Number.isNaN(parseInt(groupKey, 10))).length) {
          return Object.keys(props.errors[errorGroup]).reduce((acc, groupKey) => {
            if (!Number.isNaN(parseInt(groupKey, 10))) {
              acc.push([
                props.debug &&
                <p className='text-secondary' key={`${errorGroup}-error-array-debug`}>{errorGroup} - {groupKey}</p>,
                // $FlowIssue
                <ErrorsDrawer
                  debug={props.debug}
                  errors={props.errors[errorGroup][groupKey]}
                  key={`${errorGroup}-error-array`}
                  labelValue={`${parseInt(groupKey, 10) + 1}`}
                  prefix={`${props.prefix}${errorGroup}.`}
                  texts={props.texts[errorGroup] || props.texts}
                />
              ])
            }
            return acc
          }, [])
        } else if (typeof props.errors[errorGroup] === 'object' && !props.errors[errorGroup].error_type) {
          // $FlowIssue
          return ([
            props.debug && <p className='text-secondary' key={`${errorGroup}-error-block-debug`}>{errorGroup}</p>,
            <ErrorsDrawer
              debug={props.debug}
              errors={props.errors[errorGroup]}
              key={`${errorGroup}-error-block`}
              labelValue={props.labelValue}
              prefix={`${props.prefix}${errorGroup}.`}
              texts={props.texts[errorGroup] || props.texts}
            />
          ])
        } else if (typeof props.errors[errorGroup] === 'object' && props.errors[errorGroup].error_type) {
          return (
            // $FlowIssue
            <ErrorsPanelItem
              error={props.errors[errorGroup]}
              id={`${errorGroup}-error`}
              key={`${errorGroup}-error`}
              label={props.texts[errorGroup] || (props.debug ? `undefined ${errorGroup}` : '')}
              labelValue={props.labelValue}
              prefix={`${props.prefix}${errorGroup}.`}
              showLabel={false}
            />
          )
        }
        return null
      }))
}

export default ErrorsDrawer
